module.exports = __webpack_public_path__ + "static/img/copper_view.45d6aa41.jpg";